var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical-records 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.7928 15.7926L32.1484 30.7408C32.041 31.363 31.4965 31.8185 30.8632 31.8185H9.14097C8.50764 31.8185 7.9669 31.363 7.85579 30.7408L5.20764 15.7926C5.0669 14.9926 5.68171 14.2593 6.49282 14.2593H33.5076C34.3225 14.2593 34.9336 14.9926 34.7928 15.7926Z",
    fill: "#F9B938"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.7964 15.7926L32.1483 30.7408C32.0371 31.363 31.4964 31.8185 30.8594 31.8185H9.14085C8.50382 31.8185 7.96678 31.363 7.85196 30.7408L7.70752 29.9148H28.9557C29.589 29.9148 30.1334 29.4593 30.2409 28.8371L32.8223 14.2593H33.5075C34.3186 14.2593 34.9334 14.9926 34.7964 15.7926Z",
    fill: "#ECB021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.452 11.7111V14.2593H7.54834V9.10374C7.54834 8.59633 7.96315 8.18152 8.47427 8.18152H15.1817C15.4854 8.18152 15.7669 8.32967 15.9409 8.57782L17.1928 10.3889C17.3669 10.6371 17.6483 10.7889 17.952 10.7889H31.5224C32.0372 10.7889 32.452 11.2037 32.452 11.7111Z",
    fill: "#E5A320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.5332 23.0407C26.5332 26.6481 23.6073 29.5704 20.0035 29.5704C16.3961 29.5704 13.4702 26.6481 13.4702 23.0407C13.4702 19.4333 16.3961 16.5111 20.0035 16.5111C23.6073 16.5074 26.5332 19.4296 26.5332 23.0407Z",
    fill: "#E4E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.5295 23.0407C26.5295 26.6481 23.6036 29.5704 19.9999 29.5704C17.8184 29.5704 15.8851 28.5 14.7036 26.8629C15.7777 27.6444 17.0999 28.1 18.5258 28.1C22.1332 28.1 25.0555 25.1778 25.0555 21.5704C25.0555 20.1444 24.5999 18.8296 23.8184 17.7518C25.4666 18.9333 26.5295 20.8629 26.5295 23.0407Z",
    fill: "#D0D0F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.2815 21.8445V24.2297H21.1963V27.3223H18.8074V24.2297H15.7148V21.8445H18.8074V18.7556H21.1963V21.8445H24.2815Z",
    fill: "#F05543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.9519 23.374H15.7148V24.2296H17.9519V23.374Z",
    fill: "#E24B40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.1964 18.7556H20.3408V20.9889H21.1964V18.7556Z",
    fill: "#E24B40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.2817 21.8407V24.2296H21.1928V27.3222H18.8076V26.4666H20.341V23.374H23.4298V21.8407H24.2817Z",
    fill: "#E24B40"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.fe5c1eab597adff8389c11f5fb0992e3.svg";
export { ForwardRef as ReactComponent };